(() => {
  const requestedVariantId = new URLSearchParams(window.location.search).get('variant');

  // Ordinary product-page visits should continue opening on image one.
  if (!requestedVariantId) return;

  // This correction is only needed for Broadcast's mobile gallery.
  const isMobile =
    window.theme?.isMobile ??
    window.matchMedia('(max-width: 749px)').matches;

  if (!isMobile) return;

  const initializedProducts = new WeakSet();

  function syncInitialVariantMedia(productInfo) {
    if (!productInfo || initializedProducts.has(productInfo)) return;

    if (
      typeof productInfo.getSelectedVariant !== 'function' ||
      typeof productInfo.updateMedia !== 'function'
    ) {
      return;
    }

    const selectedVariant = productInfo.getSelectedVariant(productInfo);

    // Prevent a featured-product block or other product component from
    // responding to the main page's variant parameter.
    if (
      !selectedVariant ||
      String(selectedVariant.id) !== String(requestedVariantId)
    ) {
      return;
    }

    const mediaId = selectedVariant.featured_media?.id;
    if (!mediaId) return;

    const mediaElement = productInfo.querySelector(
      `[data-image-id="${mediaId}"]`
    );

    if (!mediaElement) return;

    initializedProducts.add(productInfo);

    const moveToSelectedMedia = () => {
      productInfo.updateMedia(mediaId);
    };

    // Wait until Broadcast has initialized and measured the mobile gallery.
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        moveToSelectedMedia();

        // A brief second pass accounts for late image/layout initialization.
        window.setTimeout(moveToSelectedMedia, 150);
      });
    });
  }

  function syncExistingProductInfo() {
    document
      .querySelectorAll('product-info')
      .forEach(syncInitialVariantMedia);
  }

  // Catches product components that initialize after this file.
  document.addEventListener('theme:product-info:loaded', (event) => {
    syncInitialVariantMedia(event.target);
  });

  // Catches components that initialized before this file loaded.
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      syncExistingProductInfo,
      { once: true }
    );
  } else {
    syncExistingProductInfo();
  }
})();